export default __webpack_public_path__ + "static/theory-animation-small-82762a47dd4e31f15c702b09bf4df50c.gif";